<button type="button" class="btn" (click)="toggle()">
  @if (!check) {
    <i class="far fa-square fa-2x"></i>
  }
  @if (check) {
    <i class="fa fa-check-square text-success fa-2x"></i>
  }
</button>
